import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
  } from '@chakra-ui/react';
  
  const DuplicateServiceModal = ({ isOpen, onClose, onConfirm, serviceName }) => {
    return (
      <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>¿Duplicar Servicio?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            ¿Estás seguro de que deseas duplicar el servicio <strong>{serviceName}</strong>?
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="gray" mr={3} onClick={onClose}>
              Cancelar
            </Button>
            <Button variant="adminPrimary" onClick={onConfirm}>
              Aceptar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  };
  
export default DuplicateServiceModal;
